import { render, staticRenderFns } from "./ProspectDealt.vue?vue&type=template&id=50bee914&scoped=true"
import script from "./ProspectDealt.vue?vue&type=script&lang=js"
export * from "./ProspectDealt.vue?vue&type=script&lang=js"
import style0 from "./ProspectDealt.vue?vue&type=style&index=0&id=50bee914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bee914",
  null
  
)

export default component.exports